<!--
 * @Description: 首页
 * @Author: xiawenlong
 * @Date: 2021-04-20 10:47:44
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-14 09:19:37
-->
<template>
  <div class="dashboard">
    <img src="@/assets/welcome.png" alt="" />
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
}
</script>
<style lang="scss" scoped>
.dashboard {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  img {
    width: 70%;
    margin-bottom: 20px;
  }
}
</style>
